module.exports = __webpack_public_path__ + "media/images/handshake-ee96c6ef2e9bbf9b4a13a0131f0d76ca.jpg";